// ABOUTME: Confirmation asked before a job retry, cancel or delete, shared by the job list and the job
// ABOUTME: detail dialog: one title and message per action, naming the job.

import { ConfirmDialog, ConfirmDialogResponse } from '@src/components/shared/ConfirmDialog';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

export type JobConfirmAction = 'retry' | 'cancel' | 'delete';

const titles = defineMessages({
    retry: { id: 'job.action.retry.title', defaultMessage: 'Retry job' },
    cancel: { id: 'job.action.cancel.title', defaultMessage: 'Cancel job' },
    delete: { id: 'job.action.delete.title', defaultMessage: 'Delete job' },
});

const messages = defineMessages({
    retry: {
        id: 'job.action.retry.confirm',
        defaultMessage: 'Retry the job {job}? A new attempt starts with the same arguments.',
    },
    cancel: {
        id: 'job.action.cancel.confirm',
        defaultMessage: 'Cancel the job {job}? A running attempt is stopped.',
    },
    delete: {
        id: 'job.action.delete.confirm',
        defaultMessage: 'Delete the job {job}? It disappears from the list.',
    },
});

interface IJobActionConfirmDialogProps {
    /** The action awaiting confirmation; null keeps the dialog closed. */
    action: JobConfirmAction | null;
    jobLabel: string;
    handleClose: (response: ConfirmDialogResponse) => void;
}

export function JobActionConfirmDialog(props: Readonly<IJobActionConfirmDialogProps>) {
    const { action, jobLabel, handleClose } = props;
    const intl = useIntl();

    return (
        <ConfirmDialog
            isOpen={action !== null}
            title={action ? intl.formatMessage(titles[action]) : ''}
            handleClose={handleClose}
        >
            {action && <FormattedMessage {...messages[action]} values={{ job: jobLabel }} />}
        </ConfirmDialog>
    );
}
